export default __webpack_public_path__ + "static/media/wildlife-cheeter.d929f48e.jpg";